import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import { SegmentedControl, Shimmer } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useCurrentEntityTimeline from '@/components/entities/components/details/hooks/use-current-entity-timeline';
import { AUDIT_TRAILS_ID } from '@/entity/constants';
import Section from '../section';
import AddFreeFormNote from './components/add-free-form-note';
import AuditTrailTimeline from './components/audit-trail-timeline';
import { type AuditTrailScope, scopeToTimelineQuery } from './components/audit-trail-timeline/utils/key-events';
export type AuditTrailProps = {
  entity: Entity;
  defaultScope?: AuditTrailScope;
};
const AuditTrail = t0 => {
  const $ = _c(26);
  const {
    entity,
    defaultScope: t1
  } = t0;
  const defaultScope = t1 === undefined ? "all" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "auditTrail"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const [scope, setScope] = useState(defaultScope);
  let t3;
  if ($[1] !== scope) {
    t3 = scopeToTimelineQuery(scope);
    $[1] = scope;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    count,
    isPending,
    error
  } = useCurrentEntityTimeline(t3);
  const isReady = !isPending && !error;
  const hasEvents = isReady && count != null && count > 0;
  const showFilter = isReady && (hasEvents || scope === "key");
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== count || $[6] !== hasEvents || $[7] !== isPending || $[8] !== t) {
    t5 = isPending ? <Shimmer height="16px" width="56px" /> : hasEvents ? <span className="text-body-3 text-tertiary">({count === 1 ? t(_temp2, {
        count
      }) : t(_temp3, {
        count
      })})</span> : null;
    $[5] = count;
    $[6] = hasEvents;
    $[7] = isPending;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isPending || $[11] !== scope || $[12] !== showFilter || $[13] !== t) {
    t6 = isPending ? <Shimmer height="28px" width="112px" /> : showFilter ? <SegmentedControl aria-label={t(_temp4)} size="compact" value={scope} onChange={setScope} options={[{
      value: "all",
      label: t(_temp5)
    }, {
      value: "key",
      label: t(_temp6)
    }]} /> : null;
    $[10] = isPending;
    $[11] = scope;
    $[12] = showFilter;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AddFreeFormNote />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6) {
    t8 = <div className="flex items-center gap-4">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== entity || $[19] !== scope) {
    t9 = <AuditTrailTimeline entity={entity} scope={scope} onChangeScope={setScope} />;
    $[18] = entity;
    $[19] = scope;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t4 || $[22] !== t5 || $[23] !== t8 || $[24] !== t9) {
    t10 = <Section title={t4} id={AUDIT_TRAILS_ID} titleSuffix={t5} suffixActions={t8}>{t9}</Section>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default AuditTrail;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.eventCountOne;
}
function _temp3($_1) {
  return $_1.eventCountOther;
}
function _temp4($_2) {
  return $_2.filter.ariaLabel;
}
function _temp5($_3) {
  return $_3.filter.all;
}
function _temp6($_4) {
  return $_4.filter.key;
}